import React, { useState } from "react";
import "./Header.scss";
import logo from "../../images/logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { label: "Inicio", href: "#inicio" },
    { label: "Servicios", href: "#servicios" },
    { label: "Proyectos", href: "#proyectos" },
    { label: "Nosotros", href: "#por-que-elegirnos" },
    { label: "Contacto", href: "#contacto" },
  ];

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header__container">
        <a href="#inicio" className="header__logo" onClick={handleLinkClick}>
          <img
            src={logo}
            alt="Yare And San Industry"
          />
        </a>

        <nav className={`header__nav ${menuOpen ? "is-open" : ""}`}>
          <ul className="header__menu">
            {navItems.map((item) => (
              <li key={item.label} className="header__menu-item">
                <a href={item.href} onClick={handleLinkClick}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <a
            href="https://wa.me/525566176657"
            target="_blank"
            rel="noreferrer"
            className="header__cta header__cta--mobile"
            onClick={handleLinkClick}
          >
            Cotizar ahora
          </a>
        </nav>

        <a
          href="https://wa.me/525566176657"
          target="_blank"
          rel="noreferrer"
          className="header__cta header__cta--desktop"
        >
          Cotizar ahora
        </a>

        <button
          type="button"
          className={`header__toggle ${menuOpen ? "is-active" : ""}`}
          onClick={handleMenuToggle}
          aria-label="Abrir menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;